import { useState, useEffect, useMemo } from 'react';
import { useProductInventoryByHandle } from '@backpackjs/storefront';

export const useProductInventoryByHandles = ({ handles = [] }) => {
  const [count, setCount] = useState(0);
  const [inventories, setInventories] = useState([]);
  const handle = useMemo(() => {
    return handles?.[count];
  }, [count]);
  const { inventory, ...inventoryStatus } = useProductInventoryByHandle({
    handle,
    withQuantity: true,
  });

  useEffect(() => {
    if (!inventory) return;
    setInventories((prevInventories) => {
      if (!prevInventories?.length) return [{ inventory, inventoryStatus }];
      if (prevInventories?.find((i) => i.inventory.handle === handle))
        return prevInventories;
      if (!inventory?.availableForSale) {
        return [...prevInventories, { inventory, inventoryStatus }];
      }
      const firstElement = prevInventories.shift();
      return [firstElement, { inventory, inventoryStatus }, ...prevInventories];
    });
    if (count < (handles?.length || 0) - 1) setCount(count + 1);
  }, [inventory]);

  if (inventories?.length !== handles?.length) return [];

  return inventories;
};
